import { atom, selector } from "recoil";
import { DateRangeType } from "types/dateRange";
import axios from "../utils/axios";
import { AssetType } from "types/common";
import { reducePriceValue } from "@api/assetLegacy";

// 키는 앱 전체에서 하나여야 한다. 예전에 `indexGlobal.ts` 를 복사해 오면서 키까지
// 그대로 가져와 두 화면(글로벌 지수 · 부동산 지수)이 **같은 칸**을 쓰고 있었다.
export const valueState = atom({
  key: "realtyIndexValueState",
  default: 0,
});

// develop 은 DateRangeSubmitEvent 가 사실상 (any) => void 라 추론 타입으로도 통과했다.
// uschool 은 제대로 타입이 붙어 있어 atom 타입을 명시해야 한다.
export const realtyIndexChartDateState = atom<DateRangeType>({
  key: "realtyIndexChartDateState",
  default: {
    begin: null,
    end: null,
  },
});

export const selectedRealtyIndexTickerState = atom<AssetType | null>({
  key: "selectedRealtyIndexTickerState",
  default: null,
});

export const analysisDataState = atom({
  key: "realtyIndexAnalysisDataState",
  default: { load: false }
})

export const realtyIndexListState = selector({
  key: "realtyIndexListState",
  get: async ({ get }) => {
    const response = await axios.get(`bts/realty/realty_indexes`);
    return response.data.data;
  },
});

export const realityIndexPriceState = selector({
  key: "realityIndexPriceState",
  get: async ({ get }) => {
    try {
      const selected = get(selectedRealtyIndexTickerState);
      if (selected === null) return;
      const { ticker } = selected;
      const dataParam = get(realtyIndexChartDateState);

      const response = await axios.get(`bts/realty/realty_indexes/${ticker}/prices`, {
        params: dataParam,
      });
      const responseObj = response.data.data;
      return reducePriceValue(responseObj);
    } catch (e) {
    }
  },
});
